import './styles/app.scss'

import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'
import React from 'react'
import i18n, { init } from '~/i18n'

import { ConnectedRouter } from 'react-router-redux'
import moment from 'moment-timezone'

import { timezone, retrieveConfig } from './config'
import store, { history } from './store'
import App from './scenes/index'


moment.tz.setDefault(timezone);

let locale = retrieveConfig('uiLanguage') || 'et';
moment.locale(locale === 'en' ? 'en-gb' : locale)

init({lng: locale.substr(0, 2)});
i18n.changeLanguage(locale.substr(0, 2), () => {
  window.i18n = i18n;
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  )
});

// load(store).then((newState) => {
//
// });
